import { ErrorIcon } from '@resiliatech/birdsong'
import { styled } from '@mui/material'

type Props = {
  hasError: boolean
}

export const StoryAiError = ({ hasError }: Props) => {
  if (!hasError) {
    return null
  }
  return (
    <Error>
      <ErrorIcon color='white' />
      <div style={{ marginLeft: '12px' }}>
        <div>Unable to generate story, please try again</div>
        <div className='copy'>
          If the issue continues, contact support@resilia.com
        </div>
      </div>
    </Error>
  )
}

const Error = styled('div')`
  display: flex;
  flex-direction: row;
  padding: 6px 16px;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 4px;
  margin: 0 24px 12px 24px;
  background: var(--error-main, #871919);
  overflow: hidden;
  transition: height 0.5s ease-in-out;
  color: var(--error-contrast, #fff);
  font-size: 16px;
  font-weight: 600;
  line-height: 120%; /* 19.2px */
  box-sizing: border-box;

  & .copy {
    font-size: 14px;
    font-weight: 400;
    line-height: 150%; /* 21px */
  }
`
